import { EnumUtils } from '../../../utils/enum-utils';
import { SectionColumnConfigCollectiveTerpeneKey } from './section-column-config-collective-terpene-key';

export const SectionColumnConfigTerpeneKey = EnumUtils.createEnum([
  ...Object.values(SectionColumnConfigCollectiveTerpeneKey),
  ...EnumUtils.getTerpenesPascalCased()
]);
